import React, { useRef, useState } from 'react'
import { useFormik } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
// import { adminMainUrl } from '../../Config';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { adminMainUrl } from "../../Config.jsx";
const DisapprovalReason = ({ show, handleClose, onSuccess, id }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const closeButtonRef = useRef(null);
    const validationSchema = Yup.object({
        disapprovalReason: Yup.string().required('Disapproval message is required'),
    });

    // Initialize Formik
    const formik = useFormik({
        initialValues: {
            id: '',
            disapprovalReason: '', // Initial value for the RequiredService type
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            values.id = id
            setIsSubmitting(true);
            try {
                const response = await fetch(`${adminMainUrl}/api/customer/document-disapproval`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'auth-token': Cookies.get('token'), // Assuming token is stored in cookies
                    },
                    body: JSON.stringify(values),
                });

                const data = await response.json();

                if (response.ok) {
                    // closeButtonRef.current.click();
                    if (onSuccess) onSuccess();
                    toast.success(data?.msg);
                    handleClose()
                    formik.resetForm();
                } else {
                    toast.error(data?.msg);
                    // Handle errors from the server
                    console.error('Error creating RequiredService Type:', data.message);
                }
            } catch (error) {
                console.error('Network error:', error);
            }
            finally {
                setIsSubmitting(false); // Stop the spinner
            }
        },
    });
    return (
        <Offcanvas className="custom-offcanvas" show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Add Disapproval Reason</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <form onSubmit={formik.handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="name" className="form-label">
                            Disapproval Reason <span style={{ color: 'red' }}>*</span>
                        </label>
                        <textarea
                            maxLength={3000}
                            rows={5}
                            className="form-control"
                            id="disapprovalReason"
                            name="disapprovalReason"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.disapprovalReason}
                        ></textarea>
                        {formik.touched.disapprovalReason && formik.errors.disapprovalReason ? (
                            <div className="error">{formik.errors.disapprovalReason}</div>
                        ) : null}
                    </div>
                    <div className="d-flex justify-content-end">
                        <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button>
                    </div>

                </form>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default DisapprovalReason